/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RevokeOrganizationRemoteSessionSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type RevokeOrganizationRemoteSessionRequest = {
  /**
   * The remote_session id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type RevokeOrganizationRemoteSessionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const RevokeOrganizationRemoteSessionSecurity$outboundSchema:
  z.ZodMiniType<
    RevokeOrganizationRemoteSessionSecurity$Outbound,
    RevokeOrganizationRemoteSessionSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function revokeOrganizationRemoteSessionSecurityToJSON(
  revokeOrganizationRemoteSessionSecurity:
    RevokeOrganizationRemoteSessionSecurity,
): string {
  return JSON.stringify(
    RevokeOrganizationRemoteSessionSecurity$outboundSchema.parse(
      revokeOrganizationRemoteSessionSecurity,
    ),
  );
}

/** @internal */
export type RevokeOrganizationRemoteSessionRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
};

/** @internal */
export const RevokeOrganizationRemoteSessionRequest$outboundSchema:
  z.ZodMiniType<
    RevokeOrganizationRemoteSessionRequest$Outbound,
    RevokeOrganizationRemoteSessionRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
      });
    }),
  );

export function revokeOrganizationRemoteSessionRequestToJSON(
  revokeOrganizationRemoteSessionRequest:
    RevokeOrganizationRemoteSessionRequest,
): string {
  return JSON.stringify(
    RevokeOrganizationRemoteSessionRequest$outboundSchema.parse(
      revokeOrganizationRemoteSessionRequest,
    ),
  );
}
